const initialState = {
  status: "invalid",
  filters: {
    open: true,
    query: {},
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "SUPPLIERS_TOGGLE_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, open: !state.filters.open },
      };
    case "SUPPLIERS_RESET_FILTERS":
      return {
        ...state,
        filters: {
          open: true,
          query: {},
        },
      };
    case "SUPPLIERS_SET_FILTERS_QUERY":
      return {
        ...state,
        filters: { ...state.filters, query: action.query },
      };
    case "SUPPLIERS_LOADING":
      return {
        ...state,
        status: "loading",
      };

    case "SUPPLIERS_SEARCHING":
      return {
        ...state,
        status: "searching",
      };
    case "SUPPLIERS_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action,
      };
    case "SUPPLIERS_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
